/**
 * Map Auto-Pan Constants
 *
 * Configuration values for automatic map panning behavior when dragging near edges.
 */

// Edge detection thresholds (pixels from edge)
export const AUTO_PAN_EDGE_THRESHOLD_MOBILE = 90;
export const AUTO_PAN_EDGE_THRESHOLD_DESKTOP = 120;

// Dead zone - minimum distance from edge before panning starts (pixels)
export const AUTO_PAN_DEAD_ZONE = 5;

// Maximum pan speed (pixels per frame)
export const AUTO_PAN_MAX_SPEED_MOBILE = 10;
export const AUTO_PAN_MAX_SPEED_DESKTOP = 15;

// Turbo zone - distance from edge where speed multiplier kicks in (pixels)
export const AUTO_PAN_TURBO_ZONE = 20;

// Speed multiplier when in turbo zone
export const AUTO_PAN_TURBO_MULTIPLIER = 1.8;

// Minimum velocity threshold for panning (pixels per ms)
export const AUTO_PAN_VELOCITY_THRESHOLD_MOBILE = 0.5;
export const AUTO_PAN_VELOCITY_THRESHOLD_DESKTOP = 0.8;

// Throttle interval for pan updates (milliseconds)
export const AUTO_PAN_THROTTLE_MS = 20;
